import {ActionTypeEnum} from "../../../../models";

export const extractTransactionParams = (searchParams: URLSearchParams) => {
    const refundTransParamValue = searchParams.get("bImDq");
    const reSalesTransParamValue = searchParams.get("rUHaU");
    const viewTransParamValue = searchParams.get("id");
    if (refundTransParamValue) {
        return { id: Number(refundTransParamValue), action: ActionTypeEnum.TransactionRefund };
    }
    if (reSalesTransParamValue) {
        return { id: Number(reSalesTransParamValue), action: ActionTypeEnum.IssueSaleTransactionFromSalePrice };
    }
    if (viewTransParamValue) {
        return { id: Number(viewTransParamValue), action: ActionTypeEnum.View };
    }
    return null;
};